export const LOCALES = ['en', 'th'] as const;
export type Locale = (typeof LOCALES)[number];
export const LOCALE_STORAGE_KEY = 'admin-lang';

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (LOCALES as readonly string[]).includes(value);
}

export function getInitialLocale(): Locale {
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
  if (isLocale(stored)) return stored;
  const nav = typeof navigator !== 'undefined' && navigator.language ? navigator.language.toLowerCase() : '';
  return nav.startsWith('th') ? 'th' : 'en';
}
